import InitializeLayout from '@js/layout';
import {initMobileBetaForm} from '@js/modules/mobileBetaForm';

InitializeLayout();

const page = document.querySelector('.mobile-app');

if (page) {
    // Sections fade in once, as they enter the viewport. Without IntersectionObserver they are shown.
    const reveals = page.querySelectorAll('.ma-reveal');
    if ('IntersectionObserver' in window) {
        page.classList.add('ma-animated');

        const revealObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-in');
                    revealObserver.unobserve(entry.target);
                }
            });
        }, {rootMargin: '0px 0px -8% 0px'});
        reveals.forEach((element) => revealObserver.observe(element));

        // The sticky phone shows the screen of the step in the middle of the viewport.
        const shots = page.querySelectorAll('[data-story-shot]');
        const steps = page.querySelectorAll('[data-step]');
        const stepObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                const step = entry.target.dataset.step;
                steps.forEach((element) => element.classList.toggle('is-active', element === entry.target));
                shots.forEach((shot) => shot.classList.toggle('is-shown', shot.dataset.storyShot === step));
            });
        }, {rootMargin: '-45% 0px -45% 0px'});
        steps.forEach((element) => stepObserver.observe(element));
    } else {
        reveals.forEach((element) => element.classList.add('is-in'));
    }

    const gallery = page.querySelector('[data-role="gallery"]');
    page.querySelectorAll('[data-gallery-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
            const direction = Number(button.dataset.galleryScroll);
            const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
            gallery.scrollBy({left: direction * gallery.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth'});
        });
    });

    const signups = page.querySelectorAll('[data-beta-signup]');
    const markJoined = () => signups.forEach((block) => {
        block.querySelector('[data-role="beta-form"]').hidden = true;
        block.querySelector('[data-role="success"]').hidden = false;
    });
    page.querySelectorAll('[data-role="beta-form"]').forEach((form) => initMobileBetaForm(form, {onSuccess: markJoined}));
}
